import { render, staticRenderFns } from "./EducationPage.vue?vue&type=template&id=5a3dec3f"
import script from "./EducationPage.vue?vue&type=script&lang=js"
export * from "./EducationPage.vue?vue&type=script&lang=js"
import style0 from "./EducationPage.vue?vue&type=style&index=0&id=5a3dec3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports